import type React from 'react';

interface IProps {}

const SubTitle: React.FC<IProps> = ({ children }) => {
  return <span className="text-sm text-gray-600">{children}</span>;
};

export default SubTitle;
